import React, { JSX } from "react";
import { Tooltip } from "@/components/common/Tooltip";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export interface MenuAction {
  id: string;
  Icon: React.ComponentType<{ className?: string }>;
  label: string;
  onClick: (e: React.MouseEvent) => void;
  disabled?: boolean;
  disabledLabel?: string;
  group?: "view" | "column";
}

interface MenuItemProps {
  Icon: React.ComponentType<{ className?: string }>;
  label: string;
  onClick: (e: React.MouseEvent) => void;
  disabled?: boolean;
  id?: string;
}

export function MenuItem({
  Icon,
  label,
  onClick,
  disabled,
  id,
}: MenuItemProps): JSX.Element {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="menu-item flex items-center gap-2 text-fg-regular whitespace-nowrap"
      id={id}
      style={{
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      <Icon className="icon-sm" />
      <span>{label}</span>
    </button>
  );
}

interface MenuGroupLabelProps {
  label: string;
  onNavigate?: (e: React.MouseEvent) => void;
}

export function MenuGroupLabel({
  label,
  onNavigate,
}: MenuGroupLabelProps): JSX.Element {
  if (onNavigate) {
    return (
      <div className="px-3 py-2 select-none">
        <Tooltip title="Select table">
          <button
            onClick={onNavigate}
            className="tab-option tab-option-active border-[0.5px] border-border cursor-pointer"
          >
            <span className="text-fg-muted-regular">{label}</span>
            <ChevronRightIcon className="icon-xs text-fg-muted" />
          </button>
        </Tooltip>
      </div>
    );
  }

  return (
    <div className="px-4 py-2 select-none">
      <span className="text-fg-muted-medium">{label}</span>
    </div>
  );
}

export function MenuDivider(): JSX.Element {
  return <div className="border-t border-border mx-2 my-1" />;
}
